import React, { useEffect, useState } from "react";
import { Button, Table, Tag, Space, Spin, Dropdown, Menu } from "antd";
import { PlusOutlined, FilePdfOutlined } from "@ant-design/icons";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../config/firebase.js";
import { useNavigate } from "react-router-dom";
import { generateInvoicePDF } from "../../config/generateInvoicePDF.js";

const statusColor = {
  draft: "orange",
  sent: "blue",
  paid: "green",
};

export default function InvoicesDashboard() {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const navigate = useNavigate();

  const fetchInvoices = async () => {
    setLoading(true);
    const q = query(collection(db, "invoices"), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);

    const list = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setInvoices(list);
    setLoading(false);
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const menuItems = [
    {
      key: "companies",
      label: "Entreprises",
      onClick: () => navigate("/admin/invoices/generate?type=company"),
    },
    {
      key: "agents",
      label: "Agents",
      onClick: () => navigate("/admin/invoices/generate?type=agent"),
    },
  ];

  const columns = [
    {
      title: "N° Facture",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Nom",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Période",
      key: "period",
      render: (_, record) => (
        <span>
          {record.period?.from?.toDate().toLocaleDateString()} — {record.period?.to?.toDate().toLocaleDateString()}
        </span>
      ),
    },
    {
      title: "Montant",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (v) => `${v.toFixed(2)} €`,
    },
    /*{
      title: "Statut",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={statusColor[status]}>{status.toUpperCase()}</Tag>,
    },*/
    {
      title: "PDF",
      key: "pdf",
      render: (_, record) => (
        <Button
          type="link"
          icon={<FilePdfOutlined />}
          //disabled={!record.pdfUrl}
          onClick={() => generateInvoicePDF(record)}
        />
      ),
    },
  ];

  const companiesInvoices = invoices.filter(
    (invoice) => invoice.type === 'company'
  );

  const agentsInvoices = invoices.filter(
    (invoice) => invoice.type === 'agent'
  );

  return (
    <Spin spinning={loading} tip="Chargement des factures...">
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <Space style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>Factures</h2>
          <Dropdown
            menu={{ items: menuItems }}
            trigger={["click"]}
          >
            <Button type="primary" icon={<PlusOutlined />}>
              Générer des factures
            </Button>
          </Dropdown>
        </Space>
        <h3>Factures des entreprises</h3>
        <Table
          columns={columns}
          dataSource={companiesInvoices}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
        <h3>Factures des agents</h3>
        <Table
          columns={columns}
          dataSource={agentsInvoices}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Space>
    </Spin>
  );
}
